import { render, staticRenderFns } from "./TableDone.vue?vue&type=template&id=10210f63&scoped=true&"
import script from "./TableDone.vue?vue&type=script&lang=js&"
export * from "./TableDone.vue?vue&type=script&lang=js&"
import style0 from "./TableDone.vue?vue&type=style&index=0&id=10210f63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10210f63",
  null
  
)

export default component.exports